import { render, staticRenderFns } from "./UserDnaCard.vue?vue&type=template&id=c1a3f6b4&scoped=true&"
import script from "./UserDnaCard.vue?vue&type=script&lang=js&"
export * from "./UserDnaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a3f6b4",
  null
  
)

export default component.exports